<template>
	<div>
		<div class="setUptitle"><i :class="icon"></i>{{name}}<slot></slot></div>
		<div v-if="lineType == 1" class="horizontalLine"></div>
		
	</div>
</template>

<script>
		export default {
			name:'commonTitle',
			props: ['icon', 'name','lineType']
		}
</script>

<style>
	.setUptitle{
		font-size:14px;
		margin-bottom:15px;
		box-sizing: border-box;
	}
	.setUptitle i{
		font-size: 18px;
		margin-right: 5px;
	}
	
</style>
